
import DeleteButton from "../../../../../components/deleteButton";
import TextField from "../../../../../components/textField/textField";
import TextFieldArtistSuggestions from "../../../../../components/textField/textFieldArtistSuggestions";
import { PerformanceDTO } from "../../../../../openapi-generated-client";
import { getSocialMediaIcon } from "../../../../single-artist/socialMediaNetwork";
import { ArtistIdNamePair } from "./editPieceContributorElement";
import "./editPiecePerformanceElement.css";

interface EditPiecePerformanceElementProps {
    performance: PerformanceDTO;
    setPerformance: (v: PerformanceDTO) => void;
    onDelete: () => void;
}

export default function EditPiecePerformanceElement(props: EditPiecePerformanceElementProps) {

    var artistBio: ArtistIdNamePair = {
        id: props.performance.performerId ?? -1,
        name: props.performance.performerName ?? ""
    }

    return <div className="performance-element">
        <div className="social-media">
            {getSocialMediaIcon(String(props.performance.type))}
        </div>
        <label>{props.performance.link}</label>

        <TextFieldArtistSuggestions setArtist={(id: number, v: string) => {
            console.log("setting artist", id, v);
            props.setPerformance({ ...props.performance, performerName: v, performerId: id });

        }}  artist={artistBio} placeholder="Enter performer" label="" onChange={(v: string) => {
            props.setPerformance({ ...props.performance, performerName: v, performerId: -1 });
        } } value={props.performance.performerName ?? ""}/>
        <TextField placeholder="Time and place..." label={""} value={props.performance.description} onChange={(v: string) => {
            props.setPerformance({...props.performance, description: v})

        }}/>
        <DeleteButton onDelete={props.onDelete}/>
    </div>
}